module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1fd3942fa102af8c13222be2ccc52e36.svg";